/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentPeopleFilterViewModel } from "../types/IndividualPaymentPeopleFilterViewModel.ts";
import { ePaymentMethodSchema } from "./ePaymentMethodSchema.ts";

export const individualPaymentPeopleFilterViewModelSchema = z.object({
  pageNumber: z.optional(z.number().int()),
  pageSize: z.optional(z.number().int()),
  personIds: z.array(z.number().int()).nullish(),
  studentName: z.string().nullish(),
  email: z.string().nullish(),
  ra: z.string().nullish(),
  cpf: z.string().nullish(),
  thirdPartyCpf: z.string().nullish(),
  thirdPartyCnpj: z.string().nullish(),
  ourNumber: z.string().nullish(),
  invoiceNumber: z.string().nullish(),
  classStudentId: z.number().int().nullish(),
  companyId: z.number().int().nullish(),
  paymentMethod: z.optional(
    z
      .lazy(() => ePaymentMethodSchema)
      .describe(
        "1 = Billet | 2 = CreditCardAprovaFacil | 3 = CreditCardMundiPagg | 4 = BankDeposit | 5 = CreditCardStripe | 6 = BilletPecegePay | 7 = CreditCardPecegePay | ",
      ),
  ),
}) as unknown as ToZod<IndividualPaymentPeopleFilterViewModel>;
